module.exports = __webpack_public_path__ + "img/ring.f46d3584.png";